import { render } from "./HubView.vue?vue&type=template&id=02d8dfff&scoped=true"
import script from "./HubView.vue?vue&type=script&lang=js"
export * from "./HubView.vue?vue&type=script&lang=js"

import "./HubView.vue?vue&type=style&index=0&id=02d8dfff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d8dfff"]])

export default __exports__